import {
  loginByUsername,
  loginByCode,
  loginByQRcode,
  logout,
  refreshToken
} from '@/api/login'
import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'
import { sentBuryPointInfo } from '@/utils/buryPoint'

const user = {
  state() {
    const user = getUser()
    return {
      token: getToken(),
      funcTreeNodesArr: [],
      ...user
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      setToken(token)
    },
    SET_USER: (state, user) => {
      state = Object.assign(state, user)
      setUser(user)
    },
    SET_FUNCTREE_NODES_ARR: (state, data) => {
      state.funcTreeNodesArr = data
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        async function func() {
          await loginByUsername(userInfo)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        }
        func()
      })
    },
    LoginByCode({ commit }, userInfo) { // 验证码登录
      return new Promise((resolve, reject) => {
        async function func() {
          await loginByCode(userInfo)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        }
        func()
      })
    },
    LoginByQRcode({ commit }, userInfo) { // 验证码登录
      return new Promise((resolve, reject) => {
        async function func() {
          await loginByQRcode(userInfo)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        }
        func()
      })
    },

    bindAndLogin({ commit }, response) { // 绑定并登录
      return new Promise((resolve, reject) => {
        async function func() {
          resolve(response)
        }
        func()
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_USER', '')
            commit('SET_MODULES', [])
            commit('SET_ROUTERS', { value: [] })
            removeToken()
            removeUser()
            resolve()
          })
          .catch(error => {
            reject(error)
          }).finally(() => {
            sentBuryPointInfo({
              eventName: '点击登出',
              eventCode: 'click',
              rsCode: 'iways-logout',
              rsName: '点击登出',
              eventContext: {
                url: '/'
              }
            })
          })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER', '')
        removeToken()
        removeUser()
        resolve()
      })
    },

    RefreshToken({ commit }, token) {
      return new Promise((resolve, reject) => {
        refreshToken({
          data: { token }
        })
          .then(response => {
            const data = response.data
            const user = getUser()
            user.token = data.token
            setUser(user)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js